<template>
  <div class="bg-gradient py-0 mx-4 py-4">
    <v-layout row wrap align-center mx-4>
      <v-flex>
        <h3 class="black--text mb-2">
          <v-btn color="" flat icon small @click="$router.go(-1)" class="elevation-0">
            <v-icon small>las la-arrow-left</v-icon>
          </v-btn>
          New support case
        </h3>
      </v-flex>
    </v-layout>
    <v-layout row wrap mx-4>
      <v-flex>
        <div class="py-4 px-3 box-container">
          <v-layout row wrap ma-0>
            <v-flex sm4 px-1>
              <v-text-field
                class="grey--text text--lighten-2"
                maxlength="100"
                readonly
                outlined
                v-model="newTicket.name"
                :error-messages="errors.collect('name')"
                name="name"
                label="Name *"
              ></v-text-field>
            </v-flex>
            <v-flex sm4 px-1>
              <v-text-field
                class="grey--text text--lighten-2"
                maxlength="100"
                readonly
                outlined
                v-model="newTicket.email"
                :error-messages="errors.collect('email')"
                name="email"
                label="Email *"
              ></v-text-field>
            </v-flex>
            <v-flex sm4 px-1>
              <v-text-field
                class="grey--text text--lighten-2"
                maxlength="100"
                outlined
                v-model="newTicket.contact_phone"
                v-validate="'required|numeric|max:18||min:6'"
                :error-messages="errors.collect('phone')"
                name="phone"
                label="Phone number *"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap ma-0>
            <v-flex px-1>
              <v-text-field
                class="grey--text text--lighten-2"
                maxlength="100"
                outlined
                v-model="newTicket.subject"
                v-validate="'required'"
                :error-messages="errors.collect('subject')"
                name="subject"
                label="Subject *"
              ></v-text-field>
            </v-flex>
            <v-flex px-1>
              <v-select
                :items="list.types"
                v-model="newTicket.type"
                name="ticketType"
                :error-messages="errors.collect('ticketType')"
                label="Ticket type *"
                item-text="title"
                data-vv-as="ticket type"
                v-validate="'required'"
                class="elevation-0 grey--text text--lighten-2"
                outlined
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap ma-0 pa-2>
            <v-flex style="border:1px solid #9e9e9e; border-radius:8px; overflow:hidden;">
              <VuePellEditor
              class="w-100"
              v-model="newTicket.description"
              placeholder="Enter description" />
            </v-flex>
          </v-layout>

          <v-layout row wrap ma-0>
            <v-flex>
              <v-flex class="text-xs-center">
                <v-btn color="primary"
                  :loading="config.loading"
                  :disabled="config.loading"
                  @click="validateDetails"
                  class="mr-2 elevation-0 float-right white--text"
                  >
                  <v-icon small class="mr-2">las la-plus</v-icon>
                  Create case
                </v-btn>
              </v-flex>
            </v-flex>
          </v-layout>

        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import VuePellEditor from 'vue-pell-editor';
// import { ContentLoader } from 'vue-content-loader';
import axios from 'axios';

Vue.use(VuePellEditor);

export default {
  name: 'support-center-tickets',
  // components: {
  //   ContentLoader
  // },
  data () {
    return {
      config: {
        loading: false
      },
      list: {
        types: [{
          title: 'Account & Billing Support',
          value: 'account'
        }, {
          title: 'Technical Support',
          value: 'technical'
        }]
      },
      newTicket: {
        ticket_source: 'Amara',
        contact_phone: '',
        description: ''
      }
    };
  },
  methods: {
    validateDetails () {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.createTicket();
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Fill all the mandatory fields!'
          });
        }
      });
    },
    createTicket () {
      this.config.loading = true;
      axios.post(`${process.env.VUE_APP_API_URL}support/add`, this.newTicket)
        .then((resp) => {
          this.config.loading = false;
          if (resp.data) {
            this.$store.dispatch('updateSnackbar', {
              color: 'success',
              show: true,
              text: 'Ticket created successfully!'
            });
            this.$router.push('/support-center');
          }
        }, (resp) => {
          this.config.loading = false;
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to create ticket, Please try again later!'
          });
          throw new Error(resp.body);
        });
    }
  },
  computed: {
    ...mapState({
      user: state => state.user
    })
  },
  beforeMount () {
    this.newTicket.name = this.user.display_name;
    this.newTicket.email = this.user.email;
  }
};
</script>

<style lang="scss" scoped>
</style>
